import lrNewTable from './_src/lrNewTable.vue'

lrNewTable.install = function(Vue) {
  Vue.component(lrNewTable.name, lrNewTable)
}

export default lrNewTable